import {
  Component,
  OnInit,
  OnDestroy,
  HostListener,
  ElementRef,
} from '@angular/core';
import { ViewsService } from '@app/services/views.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ChildLoadingService } from '@app/services/child-loading.service';
import { CourseService } from '@scaffold/services/course.service';
import {
  NotificationsService,
  NotificationItem,
} from '@services/notifications.service';
import { MoveItemService } from '@scaffold/services/move-item.service';
import { ConfirmDialog } from '@generic/confirm-dialog/confirm-dialog.component';
import { SaveDialogComponent } from '@generic/save-dialog/save-dialog.component';
import { UpdatingStatusService } from '@services/updating-status.service';
import { UserService } from '@services/user.service';
import { environment } from '@env/environment';
import { ItemsService } from '@scaffold/services/items.service';
import { ViewUpdateService } from '@scaffold/services/view-update.service';
import { PendingChangesGuard } from '@app/shared/pending-changes.guard';
import { Observable, of, Subject, Subscription } from 'rxjs';
import { VersionControlService } from '@scaffold/services/version-control.service';
import { take, takeUntil, catchError } from 'rxjs/operators';
import { PropertiesService } from '@scaffold/services/properties.service';
import { ScaffoldDialogService } from '@app/framework/dialog/scaffold-dialog.service';
import {
  ScaffoldSidebarService,
  ScaffoldSidebarRef,
} from '@app/framework/sidebar/scaffold-sidebar.service';
import { VersionSidebarComponent } from '@scaffold/sidebars/version-control/version-sidebar/version-sidebar.component';
import { SyncService } from '@scaffold/services/sync.service';
import { IframeService } from '@services/iframe.service';
import { EnvironmentService } from '@services/environment.service';
import { TranslationService } from '@services/translation.service';
import { PageTitleService } from '@services/page-title.service';
import { IntegrationSelectComponent } from '@scaffold/dialogs/integration-select/integration-select.component';
import { LoadingPageScreenService } from '@services/loading-page-screen.service';
import { Location } from '@angular/common';

@Component({
  selector: 'app-view-frame',
  templateUrl: './view-frame.component.html',
  styleUrls: ['./view-frame.component.scss'],
  standalone: false,
})
export class ViewFrameComponent
  implements OnInit, OnDestroy, PendingChangesGuard
{
  notAvailableError: boolean;
  notAuthroizedError: boolean;
  viewError: string;
  @HostListener('window:unload', ['$event'])
  unloadHandler(event) {
    if (this.itemsService.autosave) {
      this.itemsService.saveData().subscribe();
    }
  }
  //@HostListener('window:beforeunload')
  canDeactivate(): Observable<boolean> | boolean {
    let disableSave = this.itemsService.disableSave(false);
    console.log(disableSave);
    if (disableSave) {
      const text = this.translationService.getTranslatedContent(
        'there_is_an_error_in_the_input_lingo',
        'There is an error in the input, please correct to allow saving!'
      );
      this.notifications.popNotification(text, '', 5, {
        status: 'danger',
        position: 'top-begin',
        hasIcon: true,
        icon: { pack: 'fas', icon: 'exclamation-triangle' },
      });
      return false;
    }
    if (this.checkKeys(this.view_data) && this.allowDeactivate) {
      let choice: Subject<boolean> = new Subject<boolean>();
      if (this.itemsService.autosave) {
        this.isSaving = true;
        this.properties.setProperties(null);
        this.itemsService.saveData().subscribe(d => {
          console.log('complete');
          this.isSaving = false;
          choice.next(true);
        });
      } else {
        let settings: any = {
          context: {
            data: {
              title: this.translationService.getTranslatedContent(
                'unsaved_changes',
                'Unsaved Changes'
              ),
              message: this.translationService.getTranslatedContent(
                'there_may_be_unsaved_changes_in_this_view_lingo',
                'There may be unsaved changes in this view, Would you like to save?'
              ),
            },
          },
        };
        var dialogRef = this.dialog.open(SaveDialogComponent, settings);

        dialogRef.onClose.subscribe(result => {
          if (result) {
            if (result === 'save') {
              this.isSaving = true;
              this.properties.setProperties(null);
              this.itemsService.saveData().subscribe(d => {
                console.log('complete');
                this.isSaving = false;
                choice.next(true);
              });
            } else {
              this.properties.setProperties(null);
              this.view_data = {};
              this.itemsService.cancelData(true);
              this.isSaving = false;
              choice.next(true);
            }
          } else {
            this.isSaving = false;
            this.loadingPageScreenService.stopLoading();
            choice.next(false);
          }
        });
      }
      return choice;
    } else {
      return true;
    }
  }

  constructor(
    private _location: Location,
    private translationService: TranslationService,
    public syncService: SyncService,
    public viewService: ViewsService,
    private route: ActivatedRoute,
    public router: Router,
    public loading: ChildLoadingService,
    private courseService: CourseService,
    private notifications: NotificationsService,
    public movingItem: MoveItemService,
    private dialog: ScaffoldDialogService,
    public updateStatusService: UpdatingStatusService,
    private userService: UserService,
    private itemsService: ItemsService,
    private pageTitleService: PageTitleService,
    private viewUpdate: ViewUpdateService,
    private environmentService: EnvironmentService,
    private versioning: VersionControlService,
    private properties: PropertiesService,
    public iframeService: IframeService,
    private sidebar: ScaffoldSidebarService,
    public appElementRef: ElementRef,
    private loadingPageScreenService: LoadingPageScreenService
  ) {}
  /*
<button mat-menu-item (click)="push(true)" [disabled]="isSyncDisabled()">

        <span>Sync Child Course to LMS</span>
      </button>
      <button mat-menu-item (click)='pushToChildren()' [disabled]="syncingChild || isSyncDisabled()">
        <span>Push Updates to Child Courses</span>
*/
  menu: any[] = [
    {
      label: this.translationService.getTranslatedContent(
        'push_updates_to_child_courses',
        'Push Updates to Child Courses'
      ),
      command: () => this.menuClick('pushToChildren'),
    },
    {
      label: 'Sync Child Course to LMS',
      command: () => this.menuClick('push'),
    },
  ];

  savemenu: any[] = [
    /*  { title: "Disable Autosave", hidden: !this.itemsService.autosave || !this.itemsService.autosave, data: { action: 'disableAutoSave' } },
    { title: "Enable Autosave", hidden: this.itemsService.autosave || !this.itemsService.autosave, data: { action: 'enableAutoSave' } },
  */ {
      label: this.translationService.getTranslatedContent(
        'cancel_changes',
        'Cancel Changes'
      ),
      command: () => this.menuClick('cancel'),
    },
  ];

  syncmenu: any[] = [
    /*  { title: "Disable Autosave", hidden: !this.itemsService.autosave || !this.itemsService.autosave, data: { action: 'disableAutoSave' } },
    { title: "Enable Autosave", hidden: this.itemsService.autosave || !this.itemsService.autosave, data: { action: 'enableAutoSave' } },
  */ {
      label: this.translationService.getTranslatedContent(
        'restore_course',
        'Restore Course'
      ),
      command: () => this.menuClick('restore'),
    },
  ];

  courseLoad: Subscription;
  identifier = 'menu-' + Math.floor(Math.random() * 5000);
  isSaving = false;
  allowDeactivate = true;
  type: string = '';
  id: any;
  mode: string;
  course_id: any;
  course;
  view_data: any;
  view;
  showEdit;
  parent;
  destroy$: Subject<boolean> = new Subject<boolean>();
  version;
  versionMessage: NotificationItem;
  versionSidebar: ScaffoldSidebarRef;
  showVersions = true;
  showVersionPanel = false;
  updateSocket;
  trackUpdates = false;
  socketExpiration;
  socketConnectionId;
  isRoot;
  syncing;
  syncingChild;
  disableSync = true;
  disableRestore = true;
  disableSave = false;
  overriddenView = false;
  private _lastSaveVisible;
  htmlContent;
  viewErrorMessage: string;
  instanceDetails;
  ngOnInit() {
    this.userService
      .getRoleDetails()
      .pipe(take(1))
      .subscribe(user => {
        console.log(user);
        this.disableSync = user.disable_sync || !user.view_integrations;
        this.disableRestore = user.disable_restore;
        this.disableSave = user.prevent_edit;
      });
    this.environmentService
      .getInstanceDetails()
      .pipe(takeUntil(this.destroy$))
      .subscribe(details => {
        this.instanceDetails = details;
      });
    this.version = this.versioning.currentVersion;
    console.log(this);
    this.loading.startLoading();
    this.route.data.pipe(takeUntil(this.destroy$)).subscribe(v => {
      console.log(v);
      this.showEdit = v.allow_edit;
      this.isRoot = v.root;
      console.log('Reset course if in view:', this.isRoot, this.showEdit);
      //TEMP check if the route hase a childe and if this is the reed view frame. if so disable the save navigation popup and let the child view frame handle it.
      //This prevent duplicat popups
      let disableNavCheck;
      try {
        let url = this.router.routerState.snapshot.url.split(/\//g);
        console.log(url);
        if (url.length > 2) disableNavCheck = true;
        console.log(this.router.routerState.snapshot);
      } catch (e) {
        console.log(e);
      }
      if (this.isRoot && disableNavCheck) {
        this.allowDeactivate = false;
      }
      if (this.isRoot && (this.showEdit || this.type !== 'courses')) {
        this.courseService.id = null;
        this.versioning.currentVersion = null;
        this.versioning
          .watchVersion()
          .pipe(takeUntil(this.destroy$))
          .subscribe(v => {
            console.trace('Set Version', v);
            this.version = v;
            this.getViews();
          });
      }
    });

    var hasSelf = false;
    var hasParent = false;

    this.route.paramMap.pipe(takeUntil(this.destroy$)).subscribe(p => {
      console.log(p);
      this.view_data = {};
      this.id = p.get('id');
      this.itemsService.getData(this.id);
      this.type = p.get('type') || 'views';
      this.appElementRef.nativeElement.scrollTop = 0;
      if (this.type === 'courses') {
        if (this.courseService.id != this.id)
          this.versioning.currentVersion = null;
        this.courseService.id = this.id;
      }
      if (this.router.url.indexOf('/files') > 0) {
        this.showVersions = false;
      } else {
        //Temp disable versioning
        this.showVersions = false; //true;
      }
      hasSelf = true;
      if (hasSelf && hasParent) {
        this.getViews();
      }
      //trigger update for navigation rendered item
      this.viewUpdate.routeUpdated(p);
    });

    this.route.parent.params
      .pipe(takeUntil(this.destroy$))
      .subscribe(parent => {
        this.parent = parent;

        hasParent = true;
        console.log(this);
        if (hasSelf && hasParent) {
          this.getViews();
        }
        //trigger update for navigation rendered item
        this.viewUpdate.routeUpdated(parent);
      });
  }

  menuClick(action) {
    console.log(action);
    switch (action) {
      case 'push':
        this.push(true);
        break;
      case 'restore':
        this.restore();
        break;
      case 'pushToChildren':
        this.pushToChildren();
        break;
      case 'disableAutoSave':
        this.itemsService.autosave = false;
        this.savemenu[0].hidden = true;
        this.savemenu[1].hidden = false;
        break;
      case 'enableAutoSave':
        this.itemsService.autosave = true;
        this.savemenu[0].hidden = false;
        this.savemenu[1].hidden = true;
        break;
      case 'cancel':
        this.cancel();
        break;
      default:
        break;
    }
  }

  log() {
    console.log(this.itemsService);
  }

  public setTitle(newTitle: string) {
    this.pageTitleService.section = newTitle || '';
  }

  isSyncDisabled() {
    return (
      this.showPageButtons() || this.isSaving || this.versioning.currentVersion
    );
  }

  isSaveDisabled() {
    return (
      this.hasErrors(this.view_data) ||
      !this.checkKeys(this.view_data) ||
      !this.showPageButtons() ||
      this.versioning.currentVersion ||
      this.disableSave ||
      this.isSaving
    );
  }

  private getViews() {
    let viewUrl = '';
    this.view_data = {};
    if (this.type && this.id) {
      viewUrl += this.type + '/' + this.id + '?mode=read';

      if (this.type == 'courses') {
        // Cancel prev subscription
        this.trackUpdates = true;
        if (this.updateSocket) {
          this.updateSocket.unsubscribe();
        }

        //remove data stored in ItemsService when loading new course
        this.itemsService.cancelData(true);
      }
    } else {
      if (this.parent.type && this.parent.id) {
        viewUrl = this.parent.type + '/' + this.parent.id;
      }
      // Just a type in current url? parent views mode?
      viewUrl += '?mode=' + this.type;
    }
    if (this.version) {
      viewUrl += '&version=' + this.version;
    }
    this.view = { loading: true };
    //Cancel loading of view if another route ic cliked mid-load
    if (this.courseLoad?.unsubscribe) {
      this.courseLoad.unsubscribe();
    }
    this.courseLoad = this.courseService
      .get(viewUrl)
      .pipe(take(1))
      .pipe(catchError(response => of({ error: response?.error || response })))
      .subscribe(co => {
        if (co?.error) {
          this.setViewError(co.error);
          return;
        }
        const isEmptyObject =
          typeof co === 'object' && Object.keys(co || {}).length === 0;
        if (co.html) {
          this.htmlContent = co.html;
        } else {
          if (co && !isEmptyObject) {
            this.viewErrorMessage = '';
            if (co[0]) {
              co = co[0];
            }
            if (co.Event?.match(/Invalid ID/i) || isEmptyObject) {
              this.setViewError('notFound');
              return;
            }
            this.view = co;
            if (this.view.view_details)
              this.courseService.setTitle(
                this.view.view_details.mode,
                this.view.view_details.title,
                this.view.type
              );
            //if this is the root view frame, set the page title based on thew title or type of data item loaded
            if (this.isRoot) {
              this.setTitle(co.title || co.type);
              if (environment.isOPM && co.institution_id) {
                this.courseService.setPartnerId(co.institution_id);
              }
            }

            this.overriddenView =
              this.showEdit &&
              environment.opmReference != null &&
              co.institution_id != environment.opmReference;
          } else {
            // set 404 not found to true
            this.view = null;
            this.setViewError('notFound');
          }
        }
        this.loading.endLoading();
        this.viewUpdate.routeUpdated({
          type: 'view updated',
          root_title: co.title || co.type,
        });
      });
  }

  back() {
    this._location.back();
  }

  home() {
    this.router.navigate(['/home']);
  }

  setViewError(error: string) {
    let errorMessage;
    let errorPageTitle;

    if (error === 'notFound') {
      errorMessage = this.translationService.getTranslatedContent(
        'page_not_found',
        'Page Not Found'
      );
      errorPageTitle = this.translationService.getTranslatedContent(
        'not_found',
        'Not Found'
      );
    }

    if (error === 'deleted') {
      errorMessage = this.translationService.getTranslatedContent(
        'course_was_deleted',
        'Course Was Deleted'
      );
      errorPageTitle = this.translationService.getTranslatedContent(
        'deleted',
        'deleted'
      );
    }

    if (error === 'unauthorized') {
      errorMessage = this.translationService.getTranslatedContent(
        'unauthorized',
        'Unauthorized'
      );
      errorPageTitle = this.translationService.getTranslatedContent(
        'do_not_have_acceess_to_this_content',
        'Do Not Have Access to this Content'
      );
    }

    if (error && !errorMessage) {
      errorMessage =
        typeof error === 'string'
          ? error
          : this.translationService.getTranslatedContent(
              'not_found',
              'Not Found'
            );
      errorPageTitle = this.translationService.getTranslatedContent(
        'error',
        'Error'
      );
    }
    this.pageTitleService.section = errorPageTitle;
    this.viewErrorMessage = errorMessage;
    this.view = null;
  }

  private getContentValues(e) {
    e.forEach(comp => {
      console.log(comp);
      if (comp.type !== 'conditional' && comp.hasOwnProperty('name')) {
        if (comp.name.indexOf('.') < 0) this.view_data[comp.name] = comp.value;
      }
      if (comp.push) {
        this.getContentValues(comp);
      }
      if (comp.content) {
        this.getContentValues(comp.content);
      }
    });
  }

  private checkForConfigureComponent(content: any[]): boolean {
    if (!content || !Array.isArray(content)) {
      return false;
    }
    for (const comp of content) {
      if (comp && comp.type === 'hide_save_component') {
        return true;
      }
      if (comp && comp.content && Array.isArray(comp.content)) {
        if (this.checkForConfigureComponent(comp.content)) {
          return true;
        }
      }
      if (comp && comp.push && Array.isArray(comp.push)) {
        if (this.checkForConfigureComponent(comp.push)) {
          return true;
        }
      }
    }
    return false;
  }
  // });

  //   if (!this.id) {
  //     this.parentSub = this.route.parent.params.subscribe(parent => {
  //       this.parent = parent;
  //       this.viewSub =  this.viewService.getViews("/" + parent.type + "/" + parent.id + "?mode=" + p.get('type')).subscribe(co => {
  //           if (co) {
  //             if (co[0]) {
  //               co = co[0]
  //             }
  //             this.view = co;

  //             this.route.queryParams.subscribe(qp => {
  //               if (qp.forwardUrl) {
  //                 this.router.navigateByUrl(this.router.parseUrl(qp.forwardUrl));
  //               }
  //             })
  //           }
  //          this.loading.endLoading();

  //       });

  //     });
  //   } else {
  //     this.parentSub = this.route.parent.params.subscribe(parent => {
  //       this.parent = parent;
  //     });
  //     this.viewSub =  this.viewService.getViews(this.router.url.split("?")[0] + "?mode=" + (this.id ? "read" : "list")).subscribe(co => {
  //       if (co) {
  //         if (co[0]) {
  //           co = co[0]
  //         }
  //         this.view = co;
  //         this.querySub =   this.route.queryParams.subscribe(qp => {
  //           if (qp.forwardUrl) {
  //             this.router.navigateByUrl(this.router.parseUrl(qp.forwardUrl));
  //           }
  //         })
  //       }
  //       this.loading.endLoading();
  //     });
  //   }

  // });
  //

  ngOnDestroy() {
    this.loading.startLoading();
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
    if (this.isRoot && this.type === 'courses') {
      this.courseService.id = null;
      this.versioning.currentVersion = null;
      this.courseService.setPartnerId(null);
    }
    if (this.versionSidebar) this.versionSidebar.close();
  }

  logEdits() {
    console.log(this.view_data);
  }

  checkKeys(obj): boolean {
    /*if (obj && Object.keys(obj).length > 0) {
      var requiredToComplete = this.itemsService.checkRequired(this.view.id, obj);
      if (requiredToComplete.length == 0)
        return true;
      else
        return false;
    } else {
      return false;
    }*/
    let show = this.itemsService.showSave();
    if (show != this._lastSaveVisible) {
      console.log('SHOW SAVE');
      setTimeout(
        () => this.viewUpdate.triggerChangePropagation('show edit'),
        500
      );
    }
    this._lastSaveVisible = show;
    return show;
  }

  hasErrors(obj) {
    return this.itemsService.disableSave();
  }

  hasConfigureComponent(): boolean {
    if (this.view && this.view.data && this.view.data.content) {
      return this.checkForConfigureComponent(this.view.data.content);
    }
    return false;
  }

  editPage() {
    this.router.navigate(['edit'], { relativeTo: this.route });
  }

  cancel() {
    console.log('cancel');
    // cancel_changes /-> update this page for translations to be used instead of static text
    const translatedTitle = this.translationService.getTranslatedContent(
      'cancel_changes',
      'Cancel Changes'
    );
    let settings: any = {
      context: {
        data: {
          title: `${translatedTitle || 'Cancel changes'}?`,
          message:
            'Are you sure you want to cancel? You will lose all unsaved progress made on this page.',
        },
      },
    };
    var dialogRef = this.dialog.open(ConfirmDialog, settings);

    dialogRef.onClose.subscribe(result => {
      console.log(result);
      if (result) {
        this.properties.setProperties(null);
        this.view_data = {};
        this.itemsService.cancelData(true);
        // this.itemsService.routeUpdated('view updated');
        // this.getViews();
      }
    });
  }
  async push(children?) {
    /* if(this.courseService.data?.lms?.length > 0){
      this.syncing = "Started";
      this.syncService.push(this.id, this.type, this.view?.title, children).subscribe(d => {
        this.syncing = undefined;
      });
    }else{*/
    let integration = this.dialog.open(IntegrationSelectComponent);
    integration.onClose.subscribe(integration => {
      console.log('integration', integration);
      if (!integration?.selectedIntegration?.length) {
        this.syncing = undefined;
        return;
      }
      this.syncing = 'Started';
      this.syncService
        .push(
          this.id,
          this.type,
          this.view?.title,
          children,
          undefined,
          integration.selectedIntegration.map(i => i.name),
          integration.syncNewCourse,
          integration.extra
        )
        .subscribe(d => {
          this.syncing = undefined;
        });
    });
    //  }
  }

  async restore() {
    this.syncing = 'Started';
    await this.syncService.push(
      this.id,
      this.type,
      this.view?.title,
      null,
      'restore'
    );
    this.syncing = undefined;
  }

  // push(children?) {
  //   console.log('push children')
  //   //query string param pushUpdate triger step function to start on course
  //   let url = "/" + this.type + "/" + this.id + "?pushUpdate=true";
  //   if (children) {
  //     url += "&children=true;"
  //   }
  //   this.syncing = "Started";
  //   this.itemsService.saveViewData(url, { data: {} }).subscribe(d => {
  //     // console.log(d);
  //     if (d.executions && d.executions.length > 0) {
  //       let disp = d.executions[0];
  //       this.notifications.addUserNotification({
  //         icon:NotificationMessageIcon.fileExport,
  //         status: 'In Progess',text: `Syncing <b>${this.view?.title || this.id}</b>`, shouldForceOpen: true }, disp.executionArn);
  //       let update = setInterval(() => {
  //         let surl = "/" + this.type + "/" + this.id + "?executionArn=" + disp.executionArn;
  //         this.viewService.getViews(surl).subscribe(s => {
  //           //console.log(s)
  //           if (s.status === 'FAILED') {
  //             console.log("Failed");
  //             console.log(s);
  //             clearInterval(update);
  //             this.syncing = undefined;
  //             this.notifications.addUserNotification({
  //               icon:NotificationMessageIcon.fail,
  //               status: 'Syncing failed', text: `Syncing <b>${this.view?.title || this.id}</b> failed` , shouldForceOpen: true }, disp.executionArn);
  //           } else if (s.status === "SUCCEEDED") {
  //             console.log("completed");
  //             console.log(s);
  //             clearInterval(update);
  //             this.notifications.addUserNotification({
  //               icon:NotificationMessageIcon.checkmark,
  //               status: 'Completed', text:`Syncing <b>${this.view?.title || this.id}</b> completed` , shouldForceOpen: false }, disp.executionArn);
  //             this.syncing = undefined;
  //           }
  //         })
  //       }, 2000)
  //     } else if (d.error) {
  //       this.notifications.addUserNotification({
  //         icon:NotificationMessageIcon.fail,
  //         status: 'Syncing failed', text:`Syncing <b>${this.view?.title || this.id}</b> failed`, shouldForceOpen: true },''+Date.now());
  //       this.syncing = undefined;
  //     } else {
  //       this.notifications.addUserNotification({
  //         icon:NotificationMessageIcon.fail,
  //         status: 'Syncing failed', text: `Syncing <b>${this.view?.title || this.id}</b> failed - No Lms Selected` , shouldForceOpen: true }, '' + Date.now());
  //       this.syncing = undefined;
  //     }
  //   });
  // }

  pushToChildren() {
    //query string param pushUpdate triger step function to start on course
    let url = '/' + this.type + '/' + this.id + '?updateChildren=true';
    this.syncingChild = this.translationService.getTranslatedContent(
      'started',
      'Started'
    );
    this.itemsService.saveViewData(url, { data: {} }).subscribe(d => {
      this.syncingChild = this.translationService.getTranslatedContent(
        'completed',
        'Completed'
      );
      setTimeout(() => {
        this.syncingChild = null;
      }, 2000);
    });
  }

  save() {
    this.properties.setProperties(null);
    this.isSaving = true;
    this.itemsService.saveData().subscribe(d => {
      console.log(d);
      this.isSaving = false;
    });
    /* console.log(this.view_data);
     if (this.view_data && !this.showEdit && this.type != 'view') {
       delete this.view_data.data_input_error;
       delete this.view_data.view;
       this.properties.setProperties = null;

       var data = cloneDeep(this.view_data)

       var newurl = '';

       if (this.parent && this.parent.type) {
         newurl += '/' + this.parent.type + '/' + this.parent.id
       }

       if (this.id) {
         newurl += '/' + this.type + '/' + this.id
       }

       Object.keys(data).forEach(key => {
         if (typeof data[key] == 'object') {
           this.searchChildrenForDataRef(data[key]);
         }
       })

       this.viewService.saveViewData(newurl, { data: data }).subscribe(d => {
         this.view_data = {}
        // this.view = d;
         this.itemsService.routeUpdated('save');
       });
       this.view_data = {}
       this.itemsService.routeUpdated('save');
       //   if (this.id) {
       //     this.viewService.saveViewData("/" + this.type + "/" + this.id, { data: this.view_data }).subscribe(d => this.view_data = {});
       //   } else {
       //     this.viewService.saveViewData("/" + this.parent.type + "/" + this.parent.id, { data: this.view_data }).subscribe(d => this.view_data = {});
       //   }
     }
     */
  }

  getVersion(version) {
    this.version = version;
    this.getViews();
  }

  //removed data refrence to allow saving without cyclical refrence
  searchChildrenForDataRef(data) {
    console.log(data);
    if (data.data_object_ref) delete data.data_object_ref;
    Object.keys(data).forEach(key => {
      if (typeof data[key] == 'object') {
        this.searchChildrenForDataRef(data[key]);
      }
    });
  }

  showPageButtons() {
    return (
      (this.showVersions &&
        this.view &&
        this.view.versions &&
        this.view.versions.length > 0) ||
      this.showEdit ||
      this.checkKeys(this.view_data)
    );
  }

  updateOverrideView() {
    let settings: any = {
      context: {
        data: {
          title: 'Override View?',
          message:
            "Are you sure you want to override this view? Any custimzations you've made will need to be re-applied.",
        },
      },
    };
    let dialogRef = this.dialog.open(ConfirmDialog, settings);

    dialogRef.onClose.subscribe(result => {
      console.log(result);
      if (result && this.overriddenView) {
        this.viewService.updateOverrideView(this.id).subscribe(newView => {
          this.getViews();
        });
      }
    });
  }

  toggleVersion() {
    if (this.versionSidebar) {
      this.versionSidebar.close();
      return null;
    }
    let config = {
      //[id]="info.id" [type]="info.type"
      context: {
        id: this.id,
        type: this.type,
      },
    };
    this.versionSidebar = this.sidebar.open(VersionSidebarComponent, config);
    this.versionSidebar.onClose.subscribe(e => {
      this.versionSidebar = null;
    });
  }
}
